import * as firebase from "firebase/app";
import 'firebase/firebase-messaging';
import { FCMService } from "../Services/FCMService";
import getMAC from "getmac";

var firebaseConfig = {
    apiKey: "AIzaSyBntObos_tYkS4o0ZU13KhopK0iUQTLnDI",
    authDomain: "happy-milk-business.firebaseapp.com",
    databaseURL: "https://happy-milk-business.firebaseio.com",
    projectId: "happy-milk-business",
    storageBucket: "happy-milk-business.appspot.com",
    messagingSenderId: "646289025705",
    appId: "1:646289025705:web:d09e9a64ac4ec37d4d57b8"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const messaginIsSupported = firebase.messaging.isSupported();

const messaging = messaginIsSupported ? firebase.messaging() : undefined;

messaging && messaging.usePublicVapidKey("BJb8B9ozO4H9xfrOE6k5MtRN6ZS7iPkT3vl6fVTmL0U5NKbOLKdQXsfSkJHZjO6XZZE9a40cMu9zHhCMMQHYBiY");

messaginIsSupported && messaging.onTokenRefresh(() => {
    messaging.getToken().then((refreshedToken) => {
        console.log('Token refreshed.');
        // Indicate that the new Instance ID token has not yet been sent to the
        // app server.
        setTokenSentToServer(false);
        // Send Instance ID token to app server.
        let user = JSON.parse(localStorage.getItem('user'));
        if(null != user){
            sendTokenToServer(refreshedToken, user);
        }
        // ...
    }).catch((err) => {
        console.log('Unable to retrieve refreshed token ', err);
        // showToken('Unable to retrieve refreshed token ', err);
    });
});

// messaging.onMessage((payload) => {

//     console.log('Message received. ', payload);
// });

const requestToken = (user) => {
    if(messaginIsSupported){
        if (!isTokenSentToServer()) {
            messaging.getToken()
            .then((currentToken) => {
                console.log("Token : " + currentToken);
                if (currentToken) {
                    sendTokenToServer(currentToken, user);
                    // updateUIForPushEnabled(currentToken);
                } else {
                    // Show permission request.
                    console.log('No Instance ID token available. Request permission to generate one.');
                    // Show permission UI.
                    // updateUIForPushPermissionRequired();
                    setTokenSentToServer(false);
                }
            })
            .catch((err) => {
                console.log("Unable to get permission to notify.", err);
            });
        }
    }
}

const sendTokenToServer = (token, user) => {
    if(messaginIsSupported){
        let mac = "test";
        try{
            mac = getMAC();
        } catch(err){
            console.log(err);
        }
        console.log(require('os').networkInterfaces());
        console.log(mac);
        let platform = 'web';
        let body  = {
            token: token,
            device_id: mac,
            user_id: user.id,
        };

        FCMService.register(user.mobile_no, platform, body)
        .then(data => {
            console.log(data)
            setTokenSentToServer(true);
        })
        .catch(err => console.log(err));
    }
}

const unregister = (user) => {
    if(messaginIsSupported){
        if (isTokenSentToServer()) {
            let mac = "test";
            try{
                mac = getMAC();
            } catch(err){
                console.log(err);
            }
            console.log(require('os').networkInterfaces());
            console.log(mac);
            let body  = {
                device_id: mac
            };

            FCMService.unregister(body)
            .then(data => {
                console.log(data)
                setTokenSentToServer(false);
            })
            .catch(err => console.log(err)); 
        }
    }
}

function isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1';
  }

const setTokenSentToServer = (sent) => {
    window.localStorage.setItem('sentToServer', sent ? '1' : '0');
}

export { messaging, sendTokenToServer, requestToken, unregister, messaginIsSupported };